import {ActionSheetPositionType} from "@MobileOverlays/types/ActionSheetPosition.type";

export default function setActionSheetSwipeClassName(position: ActionSheetPositionType) {
    const directionClassNames = {
        1: "action-sheet__content-bottom-down",
        2: "action-sheet__content-bottom-up",
        0: "action-sheet__content-none",
    }

    return directionClassNames[position]
}